import {combineReducers} from 'redux';
import { reducer as formReducer } from 'redux-form'

import {
  key as autoLogoutKey,
  reducer as autoLogoutReducer
} from './autoLogout/index';

import {
  key as authKey,
  reducer as authReducer,
} from './auth/index';

import {
  key as patientListKey,
  reducer as patientListReducer,
} from './patientList/index';

import {
  key as socketKey,
  reducer as socketReducer,
} from './socket/index';

import {
  key as storageKey,
  reducer as storageReducer,
} from './storage/index';

import {authResetStorage} from './auth/actions';

const appReducer = combineReducers({
  [autoLogoutKey]: autoLogoutReducer,
  [authKey]: authReducer,
  [patientListKey]: patientListReducer,
  [socketKey]: socketReducer,
  [storageKey]: storageReducer,
  form: formReducer,
});


export default (state, action) => {
  if (action.type === authResetStorage().type) {
    state = undefined
  }

  return appReducer(state, action)
}


// WEBPACK FOOTER //
// ./src/util/redux/rootReducer.js